import { useSelectContext } from './useSelectState'

interface SelectPlaceholderProps {
  children: string
}

export const SelectPlaceholder = ({ children }: SelectPlaceholderProps) => {
  const { hasValue } = useSelectContext()

  if (hasValue) {
    return null
  }

  return <>{children}</>
}
